import React from 'react';
import {
  BryntumCalendar,
  BryntumCalendarProps,
} from '@bryntum/calendar-react-thin';
import './styles.css';
import { CalendarViewMode } from './types';

const CalendarLoading: React.FC<{ currentMode: CalendarViewMode }> = ({
  currentMode,
}) => {
  const calendarConfig: BryntumCalendarProps = {
    masked: { text: '' },
    mode: currentMode,
  };

  return (
    <div className="d-flex flex-column calendar-height">
      <BryntumCalendar {...calendarConfig} />
    </div>
  );
};

export default CalendarLoading;
